import { getAndroidVersion } from 'mini-device-utils/lib/utils/getAndroidVersion';
import { getDeviceRAM } from 'mini-device-utils/lib/utils/getDeviceRAM';
import { getOs, type OperatingSystem } from 'owa-user-agent';

/**
 * Returns true if the device is a candidate for Outlook Lite
 * based on the device's OS, version and RAM
 * @returns boolean
 */
export function getIsCandidateForOutlookLite() {
    const os = getOs();
    const androidVersion = getAndroidVersion();

    if (os !== 'Android' || !androidVersion) {
        return false;
    }

    // Android devices below with version < 5.1
    if (androidVersion.major < 5 || (androidVersion.major === 5 && androidVersion.minor < 1)) {
        return false;
    }

    // Android devices with version >= 5.1 and < 9
    if (androidVersion.major < 9) {
        return true;
    }

    // Android devices with version >= 9 and RAM > 3
    const deviceRAM = getDeviceRAM();
    if (!deviceRAM || deviceRAM > 3) {
        return false;
    }

    // Android devices with version >= 9 and RAM <= 3 cases below
    return true;
}
